/**
 * Integration placeholders.
 *
 * Every external identifier the onboarding lane needs lives here so they can all
 * be filled in one pass. Anything still starting with PLACEHOLDER_ is not wired up yet.
 *
 * Server side twins: the edge functions read the same names from project secrets
 * (Project Settings, Secrets). The values below are for client side use only and
 * must never hold a private key.
 */

/** Ontraport custom field that stores the member's registration link. */
export const PLACEHOLDER_ONTRAPORT_FIELD_REG_LINK = "PLACEHOLDER_ONTRAPORT_FIELD_REG_LINK";

/** Ontraport custom field that stores the member's current stage. */
export const PLACEHOLDER_ONTRAPORT_FIELD_STAGE = "PLACEHOLDER_ONTRAPORT_FIELD_STAGE";

/** Ontraport custom field that stores the date the stage last changed. */
export const PLACEHOLDER_ONTRAPORT_FIELD_STAGE_DATE = "PLACEHOLDER_ONTRAPORT_FIELD_STAGE_DATE";

/**
 * Secret names (not values) read by the edge functions.
 * Add each one in Project Settings, Secrets before going live.
 */
export const PLACEHOLDER_SECRET_NAMES = {
  /** Shared header secret the Ontraport webhook sends to mint-invite. */
  MINT_INVITE_SECRET: "PLACEHOLDER_MINT_INVITE_SECRET",
  /** Ontraport API key. */
  ONTRAPORT_API_KEY: "PLACEHOLDER_ONTRAPORT_API_KEY",
  /** Ontraport application id. */
  ONTRAPORT_APP_ID: "PLACEHOLDER_ONTRAPORT_APP_ID",
} as const;

/** DocuSeal template ids used by the lease and agreement steps in a later release. */
export const PLACEHOLDER_DOCUSEAL_TEMPLATE_IDS = {
  LEASE: "PLACEHOLDER_DOCUSEAL_TEMPLATE_LEASE",
  AFFILIATION: "PLACEHOLDER_DOCUSEAL_TEMPLATE_AFFILIATION",
} as const;

/** The public home of the portal. Registration links are always built from this. */
export const PORTAL_BASE_URL = "https://wlthystwrd.com";

/* ------------------------------------------------------------------ */
/* Release 2: intake, name review, address, lease and payment          */
/* ------------------------------------------------------------------ */

/** Ontraport custom field that stores the member's suite number. */
export const PLACEHOLDER_ONTRAPORT_FIELD_SUITE = "PLACEHOLDER_ONTRAPORT_FIELD_SUITE";

/** Video shown on the lease page. Leave empty to show the placeholder card. */
export const PLACEHOLDER_LEASE_VIDEO_URL = "";

/** The automation lane that creates the lease signing session and redirects to it. */
export const N8N_SUBLEASE_SIGN_URL = "https://sign.wealthysteward.com/lease";


/** The order form members are sent to for the monthly suite fee. */
export const ONTRAPORT_ORDER_FORM_URL = "https://wealthysteward.com/sublease";


/** Where the team is alerted when a name has waited too long. */
export const PLACEHOLDER_TEAM_ALERT_EMAIL = "PLACEHOLDER_TEAM_ALERT_EMAIL";

/** The permanent address members may use, with N replaced by their suite number. */
export const PLATFORM_ADDRESS_TEMPLATE = "3810 Broadway Suite 100-{N}, Sacramento, CA 95817";

/** The monthly fee for the platform address, in whole dollars. */
export const PLATFORM_ADDRESS_MONTHLY_FEE = 19;

/**
 * More secret names (not values) read by the edge functions.
 * Add each one in Project Settings, Secrets before going live.
 */
export const PLACEHOLDER_SECRET_NAMES_RELEASE_2 = {
  /** Mail service key used by send-transactional-email. */
  RESEND_API_KEY: "PLACEHOLDER_RESEND_API_KEY",
  /** Shared header secret on the signing completion webhook. */
  DOCUSEAL_WEBHOOK_SECRET: "PLACEHOLDER_DOCUSEAL_WEBHOOK_SECRET",
  /** Shared header secret on the purchase webhook. */
  PAYMENT_WEBHOOK_SECRET: "PLACEHOLDER_PAYMENT_WEBHOOK_SECRET",
} as const;
